// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"ea68b10f","75":"3ae97be3","101":"8a9ceb94","212":"b168c5a2","227":"f37603c7","239":"6e139c0a","524":"add7fd65","652":"bd76d076","736":"deeb5d04","818":"2ad02d2f","902":"220dc4b7","909":"269b6d68","933":"7a901c15"}[chunkId] + ".chunk.js";
};